(() => {
  const config = document.getElementById('dt-cart-offer-config')?.dataset || {};
  const code = config.code || '';
  const key = `__Host-dt_offer_removed_${encodeURIComponent(code)}`;
  let removed = false;
  let pending = null;
  removed = document.cookie.split(';').some((value) => value.trim() === `${key}=1`);

  function rememberRemoval(value) {
    removed = value;
    document.cookie = `${key}=${value ? '1' : ''}; Path=/; SameSite=Lax; Secure${value ? '' : '; Max-Age=0'}`;
  }

  function codes(cart) {
    return (cart.discount_codes || []).map((entry) => entry.code);
  }

  function applied(cart) {
    return cart.total_discount > 0 && (cart.discount_codes || []).some(
      (entry) => entry.code.toUpperCase() === code.toUpperCase() && entry.applicable
    );
  }

  async function request(url, body) {
    const response = await fetch(url, {
      method: body ? 'POST' : 'GET',
      headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
      ...(body ? { body: JSON.stringify(body) } : {}),
      signal: AbortSignal.timeout(6000),
    });
    if (!response.ok) throw new Error('Cart request failed');
    return response.json();
  }

  function status(message) {
    document.querySelectorAll('.dt-cart-offer__status').forEach((node) => {
      if (node.textContent !== message) node.textContent = message;
    });
  }

  // Read Shopify before each mutation; never overwrite another code or infer buyer identity.
  async function change(action, sections = [], allowApply = true) {
    const cart = await request(`${routes.cart_url}.js`);
    if (!cart.item_count) return { cart, changed: false };
    const currentCodes = codes(cart);
    if (action === 'apply' && (!allowApply || config.enabled !== 'true' || config.returning === 'true' || !code ||
      cart.total_discount > 0 || currentCodes.length > 0)) return { cart, changed: false };
    if (action === 'remove' && !currentCodes.some((value) => value.toUpperCase() === code.toUpperCase())) {
      return { cart, changed: false };
    }
    const discount = action === 'remove'
      ? currentCodes.filter((value) => value.toUpperCase() !== code.toUpperCase()).join(',')
      : code;
    const updated = await request(routes.cart_update_url, { discount, sections, sections_url: window.location.pathname });
    return { cart: updated, changed: true };
  }

  function exclusive(work) {
    if (pending) return pending;
    pending = work().finally(() => { pending = null; status(''); connect(); });
    connect();
    return pending;
  }

  // Offers are chosen explicitly at checkout. Adding a product must not apply
  // a discount, replace an existing code, or trigger a discount celebration.
  async function afterAdd(response) {
    return response;
  }

  function celebrate() {
    if (config.returning === 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const host = document.querySelector('cart-drawer.active .drawer__inner') || document.querySelector('#main-cart-footer .cart__blocks');
    if (!host || !host.querySelector('[data-dt-offer-applied]')) return;
    host.querySelector('.dt-offer-confetti')?.remove();
    const confetti = document.createElement('span');
    confetti.className = 'dt-offer-confetti';
    confetti.setAttribute('aria-hidden', 'true');
    for (let i = 0; i < 36; i++) {
      const piece = document.createElement('i');
      piece.style.setProperty('--x', `${(i * 37) % 100}%`);
      piece.style.setProperty('--delay', `${(i % 6) * 55}ms`);
      piece.style.setProperty('--turn', `${i % 2 ? -270 : 270}deg`);
      confetti.append(piece);
    }
    host.append(confetti);
    setTimeout(() => confetti.remove(), 2400);
  }

  function connect() {
    document.querySelectorAll('[data-dt-offer-action][hidden]').forEach((button) => { button.hidden = false; });
    // Prevent a quantity/remove request from racing the native discount update.
    document.querySelectorAll('cart-drawer input[name="updates[]"], cart-drawer quantity-input button, cart-drawer cart-remove-button button, cart-items input[name="updates[]"], cart-items quantity-input button, cart-items cart-remove-button button').forEach((control) => {
      if (pending && !control.disabled) {
        control.dataset.dtOfferLocked = 'true';
        control.disabled = true;
      } else if (!pending && control.dataset.dtOfferLocked === 'true') {
        delete control.dataset.dtOfferLocked;
        control.disabled = false;
      }
    });
    if (pending) status('Checking your offer…');
  }
  document.addEventListener('click', async (event) => {
    const checkout = event.target.closest('a.cart__checkout-button');
    if (!checkout || !pending) return;
    event.preventDefault();
    try { await pending; } catch (_) { /* Native checkout can still proceed. */ }
    window.location.assign(checkout.href);
  });
  document.addEventListener('submit', async (event) => {
    if (!pending || event.submitter?.name !== 'checkout') return;
    event.preventDefault();
    const form = event.target;
    const submitter = event.submitter;
    try { await pending; } catch (_) { /* Native checkout can still proceed. */ }
    form.requestSubmit(submitter);
  });
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-dt-offer-action]');
    if (!button || pending) return;
    const action = button.dataset.dtOfferAction;
    if (action === 'remove') rememberRemoval(true);
    else rememberRemoval(false);
    button.disabled = true;
    status(action === 'remove' ? 'Removing discount…' : 'Checking your offer…');
    try {
      const result = await exclusive(() => change(action));
      await publish(PUB_SUB_EVENTS.cartUpdate, { source: 'dt-cart-offer', cartData: result.cart });
      status(action === 'remove' ? '' : applied(result.cart) ? '' : 'This offer could not be applied. You can check eligibility at checkout.');
      if (action === 'apply' && applied(result.cart)) celebrate();
      const target = document.querySelector(`cart-drawer.active [data-dt-offer-action], #main-cart-footer [data-dt-offer-action]`);
      target?.focus({ preventScroll: true });
    } catch (_) {
      status('Unable to update the discount. Please try again or continue to checkout.');
    } finally {
      button.disabled = false;
    }
  });
  connect();
  new MutationObserver(connect).observe(document.documentElement, { childList: true, subtree: true });
  window.DTCartOffer = { afterAdd, celebrate };
})();
